import React from "react";
import failureIconForModal from "@src/assets/svg/failure-icon-for-modal.svg";
import { Button } from "@src/components/atoms/buttons/button/button";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import styles from "./ota-installation-failed-modal.module.scss";
import { useOtaInstallationFailedModal } from "./use-ota-installation-failed-modal";

const cssClassName = "ota-installation-failed-modal";

interface OTAInstallationFailedModalProps {
  activeInstallationData: ActiveInstallationProcessPayload;
  onClose: () => void;
}

const OTAInstallationFailedModal = ({
  activeInstallationData,
  onClose,
}: OTAInstallationFailedModalProps) => {
  const { texts, errorData, firmwareName, handleCloseModal } =
    useOtaInstallationFailedModal(activeInstallationData);

  const closeModal = () => {
    handleCloseModal();
    onClose();
  };

  return (
    <div className={styles[cssClassName]}>
      <div
        className={styles[`${cssClassName}__overlay`]}
        aria-label={texts.closeModalAriaLabel}
      />
      <div className={styles[`${cssClassName}__dialog-wrapper`]}>
        <div
          className={styles[`${cssClassName}__modal-body`]}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles[`${cssClassName}__header`]}>
            <h2 className={styles[`${cssClassName}__title`]}>{texts.title}</h2>
          </div>

          <div className={styles[`${cssClassName}__content`]}>
            <img
              src={failureIconForModal}
              alt=""
              className={styles[`${cssClassName}__failure-icon`]}
            />

            <h3 className={styles[`${cssClassName}__subtitle`]}>
              {texts.subtitle}
            </h3>

            <div className={styles[`${cssClassName}__failure-details`]}>
              <p className={styles[`${cssClassName}__error-details`]}>
                {firmwareName && (
                  <>
                    {texts.installationTypeLabel}{" "}
                    <span
                      className={styles[`${cssClassName}__firmware-name`]}
                      title={firmwareName}
                    >
                      {firmwareName}
                    </span>
                  </>
                )}
                {errorData.errorCode && ` : ${errorData.errorCode}`}
              </p>
              <p className={styles[`${cssClassName}__error-details`]}>
                {texts.installationDetails}
              </p>
              {errorData.title && (
                <p className={styles[`${cssClassName}__error-details`]}>
                  {errorData.title}
                </p>
              )}
              {errorData.detail && errorData.recommendedAction && (
                <p>
                  {errorData.detail}, {errorData.recommendedAction}
                </p>
              )}
            </div>
          </div>

          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <Button fun={closeModal} text={texts.closeButtonText} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTAInstallationFailedModal;
